<template>
  <div
    class="datepicker"
    style="z-index: 2; position: relative"
    :class="{ 'd-inline-block': hidden }"
  >
    <input
      v-show="!hidden"
      v-model="date"
      class="form-control input input-with-label"
      placeholer=" "
      :disabled="disabled"
      :tabindex="tabindex"
      :class="[inputClass]"
      @blur="checkFormat"
    />
    <label
      v-if="label"
      :class="{ 'label-placeholder': date === '' || date === null }"
      >{{ label }}</label
    >
    <i v-if="showIcon && (!clearable || !date)" class="fa fa-calendar"></i>
    <i
      v-if="clearable && date"
      class="clear-button fas fa-times hover-medium-blue"
      @click="date = null"
    ></i>
  </div>
</template>

<script>
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/themes/base/all.css";

export default {
  name: "DatePicker",
  props: {
    dateFormat: { type: String, required: false, default: "yy-mm-dd" },
    initial: { type: String, required: false, default: "" },
    showIcon: { type: Boolean, required: false, default: false },
    label: { type: String, required: false, default: "" },
    disabled: { type: Boolean, required: false, default: false },
    hidden: { type: Boolean, default: false },
    isButton: { type: Boolean, default: false },
    buttonText: { type: String, default: "" },
    tabindex: { type: Number, default: -1 },
    clearable: { type: Boolean, default: false },
    inputClass: { type: String, default: "" },
  },
  data() {
    return {
      date: this.initial ? this.initial : "",
    };
  },
  watch: {
    date(val) {
      //if (val.getTime() === val.getTime()) this.$emit("update", val);
    },
    initial(val) {
      this.date = val;
    },
  },
  mounted: function () {
    var self = this;

    let datepickerConfig = {
      onSelect: function (date) {
        self.$emit("update", date);
        self.date = date;
      },
      buttonText: this.buttonText,
      dateFormat: this.dateFormat,
      autoSize: true,
      firstDay: 1,
      changeMonth: true,
      changeYear: true,
      yearRange: "1901:2099",
      dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      monthNames: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
      monthNamesShort: [
        "Jan",
        "Feb",
        "Mrz",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez",
      ],
    };

    if (this.isButton) {
      datepickerConfig.showOn = "button";
      datepickerConfig.buttonImage = null;
    }

    $(this.$el.childNodes[0]).datepicker(datepickerConfig);
  },
  beforeDestroy: function () {
    $(this.$el).datepicker("hide").datepicker("destroy");
  },
  methods: {
    clear() {
      this.date = "";
    },
    checkFormat() {
      if (this.date == null) this.date = "";

      if (this.date != "" && !this.date.includes(".")) {
        let left = this.date.substring(0, 2);
        let mid = this.date.substring(2, 4);
        let right = this.date.substring(4, 8);

        if (right.length == 2) {
          if (parseInt(right) < 30) right = "20" + right;
          else right = "19" + right;
        }

        this.date = left + "." + mid + "." + right;
      }

      this.$emit("update", this.date);
    },
  },
};
</script>

<style lang="scss">
</style>
